var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMicrophoneWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.51455 4.01613L1.49842 0L0 1.49842L19.5446 21.043L21.043 19.5446L16.9182 15.4198C17.8041 14.121 18.322 12.5512 18.322 10.8605C18.322 10.3012 17.8686 9.84779 17.3093 9.84779C16.7501 9.84779 16.2967 10.3012 16.2967 10.8605C16.2967 11.9899 15.9885 13.0473 15.4517 13.9533L14.3576 12.8592C14.9411 12.0341 15.284 11.0266 15.284 9.93913V5.8884C15.284 3.09195 13.017 0.824974 10.2206 0.824974C8.08547 0.824974 6.25904 2.14646 5.51455 4.01613ZM7.18885 5.69043L12.8897 11.3913C13.1249 10.9599 13.2586 10.4651 13.2586 9.93913V5.8884C13.2586 4.21053 11.8984 2.85034 10.2206 2.85034C8.6092 2.85034 7.29084 4.10483 7.18885 5.69043ZM5.15714 9.93913V9.2199L10.8952 14.958C10.6745 14.9874 10.4493 15.0026 10.2206 15.0026C7.42411 15.0026 5.15714 12.7356 5.15714 9.93913ZM10.2206 16.9366C11.0081 16.9366 11.7607 16.7867 12.4513 16.514L13.9773 18.0401C13.1385 18.48 12.213 18.7771 11.2332 18.8993V20.9873C11.2332 21.5466 10.7798 22 10.2206 22C9.66127 22 9.20787 21.5466 9.20787 20.9873V18.8993C5.21151 18.4009 2.11908 14.9918 2.11908 10.8605C2.11908 10.3012 2.57248 9.84779 3.13177 9.84779C3.69106 9.84779 4.14445 10.3012 4.14445 10.8605C4.14445 14.2162 6.86482 16.9366 10.2206 16.9366Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMicrophoneWhite);
export default __webpack_public_path__ + "static/media/icon-microphone-white.668d2c76580889711d973a9da52d9977.svg";
export { ForwardRef as ReactComponent };